import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RecipientSuggestions"*/ './lazyIndex'),
    { name: 'RecipientSuggestions' }
);

export const lazySearchSuggestionsForSinglePersona: LazyImport<
    typeof lazyIndex.searchSuggestionsForSinglePersona,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.searchSuggestionsForSinglePersona);

export const lazyLogResponseReceived: LazyImport<
    typeof lazyIndex.logResponseReceived,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.logResponseReceived);
export const lazyLogRenderLayout: LazyImport<typeof lazyIndex.logRenderLayout, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.logRenderLayout);
export const lazyLogClientDataSource: LazyImport<
    typeof lazyIndex.logClientDataSource,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.logClientDataSource);
export const lazyLogSearchActions: LazyImport<
    typeof lazyIndex.logSearchActions,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.logSearchActions);
export const lazyLogManuallyAddedContact: LazyImport<
    typeof lazyIndex.logManuallyAddedContact,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.logManuallyAddedContact);
